import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';
import InputLabel from 'components/InputLabel/index';
import dayjs from 'dayjs';

/**
 * GeneralLeaseInformation component renders the general lease information section
 * with form fields for the lease record management.
 *
 * This component should be rendered within a Form component context since it uses
 * Form.Item components that depend on the form context.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.screen - Current screen mode ('CREATE', 'EDIT', or 'VIEW')
 * @param {Object} props.constantFormValues - Form configuration values
 * @param {Object} props.statusData - Current status data of the lease (for non-CREATE screens)
 *
 * @returns {JSX.Element} The General Lease Information form section
 */
const GeneralLeaseInformation = ({ screen, constantFormValues, statusData }) => {
	return (
		<Row gutter={[16, 0]}>
			<Form.Item noStyle name={constantFormValues?.version?.key}></Form.Item>
			<Form.Item noStyle name={constantFormValues?.paymentModalitylabel?.key}></Form.Item>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.LeaseId?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.LeaseId?.key}>
					<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseType?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseType?.key} rules={constantFormValues?.leaseType?.rules}>
					<Select
						disabled={screen === 'VIEW'}
						showSearch
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						filterOption={true}
						placeholder="Select from the list"
						optionFilterProp="children"
					>
						{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
							<Select.Option key={key} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseTitle?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseTitle?.key} rules={constantFormValues?.leaseTitle?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.lessorName?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.lessorName?.key} rules={constantFormValues?.lessorName?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.paymentFrequency?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.paymentFrequency?.key} rules={constantFormValues?.paymentFrequency?.rules}>
					<Select
						disabled={screen === 'VIEW'}
						showSearch
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						filterOption={true}
						placeholder="Select from the list"
						optionFilterProp="children"
					>
						{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
							<Select.Option key={key} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.paymentModality?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.paymentModality?.key} rules={constantFormValues?.paymentModality?.rules}>
					<Select
						disabled={screen === 'VIEW'}
						showSearch
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						filterOption={true}
						placeholder="Select from the list"
					>
						{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
							<Select.Option key={key} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col>

			{screen !== 'CREATE' && (
				<>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.creationDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item name={constantFormValues?.creationDate?.key}>
							<DatePicker
								type="date"
								disabled={screen === 'VIEW' || screen === 'EDIT'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							/>
						</Form.Item>
					</Col>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.lastModifiedDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item
							initialValue={statusData?.lastModifiedDate ? dayjs(statusData?.lastModifiedDate) : null}
							name={constantFormValues?.lastModifiedDate?.key}
						>
							<DatePicker
								disabled={screen === 'VIEW' || screen === 'EDIT'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								showTime={false}
								// defaultValue={statusData?.lastModifiedDate ? dayjs(statusData?.lastModifiedDate) : null}
							/>
						</Form.Item>
					</Col>
				</>
			)}
		</Row>
	);
};

export default GeneralLeaseInformation;
